const TRANSITIONS = {
    GEN8: 'Transitions™ Signature® GEN 8™',
    GENS: 'Transitions™ GEN S™',
    PHOTOCHROMIC: 'Photochromic',
    XTRACTIVE: 'Transitions™ XTRActive®',
    XTRACTIVE_POLAR: 'Transitions™ XTRActive® Polarized™',
};

export const TRANSITION_TYPES_FOR_SKU = {
    'photo-brown': TRANSITIONS.PHOTOCHROMIC,
    'photo-gray': TRANSITIONS.PHOTOCHROMIC,
    'trans-amber': TRANSITIONS.GENS,
    'trans-amethyst': TRANSITIONS.GENS,
    'trans-brown': TRANSITIONS.GENS,
    'trans-emerald': TRANSITIONS.GENS,
    'trans-gray': TRANSITIONS.GENS,
    'trans-green': TRANSITIONS.GENS,
    'trans-sapphire': TRANSITIONS.GENS,
    'trans-xtra-active-brown': TRANSITIONS.XTRACTIVE,
    'trans-xtra-active-gray': TRANSITIONS.XTRACTIVE,
    'trans-xtra-active-polar-gray': TRANSITIONS.XTRACTIVE_POLAR,
};

export type TransitionsForSkuType = keyof typeof TRANSITION_TYPES_FOR_SKU;

export const SG_LENS_PACKAGE_TITLE = {
    'Index1.5': 'Value',
    'Index1.53-HC': 'Trivex',
    'Index1.59-HC': 'Polycarbonate',
    'Index1.59-HMX': 'Polycarbonate Plus',
    'Thin1.61': 'Standard',
    'Thin1.67': 'Super',
};
